import { commonAttributes, tableColumnDefaultOption } from 'app/config'
import { validateNotEmpty } from 'app/validators'

import { PLANNER_LEVEL_OPTIONS } from '../constants'

export const columns = [
  { ...commonAttributes.uuid },
  {
    name: 'name',
    label: 'Name',
    validate: validateNotEmpty,
    ...tableColumnDefaultOption
  },
  {
    name: 'level_code',
    label: 'Level',
    widget: 'select',
    valueLabelMappings: PLANNER_LEVEL_OPTIONS,
    ...tableColumnDefaultOption
  },
  { name: 'emoji', label: 'Emoji', optional: true, ...tableColumnDefaultOption },
  { name: 'color', label: 'Color', optional: true, ...tableColumnDefaultOption },
  { name: 'display_order', label: 'Order', ...tableColumnDefaultOption },
  { name: 'is_active', label: 'Active', ...tableColumnDefaultOption }
]
